import { sliderAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { getColorVar } from '@chakra-ui/theme-tools';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(sliderAnatomy.keys);

const baseStyle = definePartsStyle(({ theme }) => ({
  filledTrack: {
    bg: 'green.600',
  },
  thumb: {
    bg: 'green.500',
    _light: {
      bg: 'green.600',
    },
    _focusVisible: {
      boxShadow: 'none',
      outline: '2px solid',
      outlineOffset: 0,
      outlineColor: 'state.selected',
      _light: {
        outlineColor: `color-mix(in srgb,${getColorVar(theme, 'state.selected')} 50%,transparent)`,
      },
    },
  },
  track: {
    bg: 'gray.200',
  },
}));

export const RangeSliderStyles = defineMultiStyleConfig({ baseStyle });
